import React from "react";
import DashIcon from "./DashIcon";

/**
 * StatusList – reusable vertical list card.
 * Props:
 *   title       – card heading
 *   items       – array of { label, value, iconType, color }
 *   dropdown    – label for the top-right dropdown (default "All")
 */
const StatusList = ({ title, items, dropdown = "All", headingIcon = "document" }) => {
  return (
    <div className="ops-card ops-status-list-card">
      <div className="ops-card-header">
        <div className="ops-card-heading">
          <span className="ops-card-heading-icon ops-heading-status">
            <DashIcon type={headingIcon} size={17} color="#fff" />
          </span>
          <span className="ops-card-title">{title}</span>
        </div>
        <select className="ops-dropdown">
          <option>{dropdown}</option>
        </select>
      </div>

      <div className="ops-status-list">
        {items.map((item, idx) => (
          <React.Fragment key={item.label}>
            <div className="ops-status-row">
              <div className="ops-status-left">
                <span
                  className="ops-status-icon-wrap"
                  style={{ background: item.color + "18" }}
                >
                  <DashIcon type={item.iconType} size={16} color={item.color} />
                </span>
                <span className="ops-status-label">{item.label}</span>
              </div>
              <span className="ops-status-value" style={{ color: item.color }}>
                {item.value}
              </span>
            </div>
            {idx < items.length - 1 && <div className="ops-divider" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StatusList;
